import { render } from "./SelectVehicle.vue?vue&type=template&id=485bf8bb&scoped=true"
import script from "./SelectVehicle.vue?vue&type=script&lang=js"
export * from "./SelectVehicle.vue?vue&type=script&lang=js"

import "./SelectVehicle.vue?vue&type=style&index=0&id=485bf8bb&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-485bf8bb"]])

export default __exports__